<template>
  <article class="guide-card">
    <router-link class="card-media" :to="guidePath(post.slug)" tabindex="-1" aria-hidden="true">
      <img v-if="post.heroImageUrl" :src="post.heroImageUrl" :alt="post.heroImageAlt || ''" loading="lazy">
    </router-link>
    <div class="card-body">
      <router-link class="card-cat" :to="categoryPath(post.categorySlug)">{{ post.category }}</router-link>
      <h2 class="card-title"><router-link :to="guidePath(post.slug)">{{ post.title }}</router-link></h2>
      <p class="card-excerpt">{{ post.metaDescription }}</p>
      <div class="card-meta"><span>{{ formatGuideDate(post.publishedAt) }}</span><span class="sep">·</span><span>{{ post.readMinutes }} min read</span></div>
      <div class="card-foot">
        <router-link class="card-read" :to="guidePath(post.slug)">Read guide →</router-link>
        <button type="button" class="card-share" @click="copyLink(guideUrl(post.slug))">Copy link</button>
      </div>
    </div>
  </article>
</template>

<script setup>
import { categoryPath, formatGuideDate, guidePath, guideUrl } from './guideFormat'
import { useGuideToast } from './useGuideToast'

defineProps({ post: { type: Object, required: true } })
const { copyLink } = useGuideToast()
</script>
